import { render, staticRenderFns } from "./ModalContentDeposting.vue?vue&type=template&id=842d823a"
import script from "./ModalContentDeposting.vue?vue&type=script&lang=js"
export * from "./ModalContentDeposting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports